import React from "react";
import { css } from "@emotion/core";
import BarLoader from "react-spinners/BarLoader";

// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    height: 2px;
    box-shadow: 0 1px 5px 0 #e4f4ff;
    transition: 0.4s width;
`;

/*a

  robar a be-progress-container
    max-width: 100%;
    height: 2px;
    background: #0061d5;
    box-shadow: 0 1px 5px 0 #e4f4ff;
    transition: .4s width;
*/

const Loader = (props) => (
    <div className="sweet-loading">
        <BarLoader css={override} size={20} width="100%" color={"#0061d5"} loading={props.loading} />
    </div>
);

export default Loader;
